import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
var axios = require("axios");
var FormData = require("form-data");
import ScriptTag from "react-script-tag";
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const EditProduct = (props) => {
  let product = props.location.query.item;
  console.log(product);
  const [new_product, set_new_product] = useState(null);

  const [last_product_id, setLast_product_id] = useState(
    product.last_product_id
  );
  const [last_product_type, setLast_product_type] = useState(
    product.last_product_type
  );
  console.log(product);
  const [title, setTitle] = useState(product.title);
  const [slug, set_slug] = useState(product.slug);
  const [type, setType] = useState(product.type);
  const [little_des, setLittleDes] = useState(product.little_description);
  const [des, setDes] = useState(product.description);
  const [price, setPrice] = useState(product.price);
  const [original_price, set_original_price] = useState(product.original_price || "");
  const [support_price, set_support_price] = useState(product.support_price);
  const [discount, setDiscount] = useState(product.discount);
  const [instagram, set_instagram] = useState(Boolean(product.instagram));
  const [box1Title, setBox1Title] = useState(product.box1.title);
  const [box2Title, setBox2Title] = useState(product.box2.title);
  const [box3Title, setBox3Title] = useState(product.box3.title);
  const [box4Title, setBox4Title] = useState(product.box4.title);
  const [box5Title, setBox5Title] = useState(product.box5.title);
  const [box6Title, setBox6Title] = useState(product.box6.title);
  const [box1Description, setBox1Description] = useState(
    product.box1.description
  );
  const [box2Description, setBox2Description] = useState(
    product.box2.description
  );
  const [box3Description, setBox3Description] = useState(
    product.box3.description
  );
  const [box4Description, setBox4Description] = useState(
    product.box4.description
  );
  const [box5Description, setBox5Description] = useState(
    product.box5.description
  );
  const [box6Description, setBox6Description] = useState(
    product.box6.description
  );
  const [cover_img, set_cover_img] = useState(product.cover_img);
  const [cover_video, set_cover_video] = useState(product.cover_video);
  const [content_img, set_content_img] = useState(product.content_img);
  const [ineligible, set_ineligible] = useState(product.ineligible);
  const [is_hidden, set_is_hidden] = useState(Boolean(product.is_hidden));
  const [consultation_only, set_consultation_only] = useState(Boolean(product.consultation_only));
  const [store_category, set_store_category] = useState(product.store_category || "");
  const [sku, set_sku] = useState(product.sku || "");
  const [stock, set_stock] = useState(product.stock || 0);
  const [shipping_note, set_shipping_note] = useState(product.shipping_note || "");
  const [store_specs_text, set_store_specs_text] = useState(
    (product.store_specs || []).map((item) => `${item.label || ""}: ${item.value || ""}`).join("\n")
  );
  const [store_gallery, set_store_gallery] = useState(product.store_images || []);
  const [new_store_images, set_new_store_images] = useState([]);

  let history = useHistory();

  const updateStoreGallery = () => {
    const formData = new FormData();
    formData.append("product_id", product._id);
    formData.append("gallery_manifest", JSON.stringify(store_gallery));
    new_store_images.forEach((file) => formData.append("store_images", file));
    formData.append("store_image_alts", JSON.stringify(new_store_images.map(() => title || "تصویر محصول")));
    storage.load("token").then((token) => {
      if (!token) return Promise.reject();
      return Axios.post("/update_store_gallery", formData, {
        headers: { "x-auth": token, "Content-Type": "multipart/form-data" },
      });
    }).then((res) => {
      set_store_gallery(res.data.product.store_images || []);
      set_new_store_images([]);
      utils.showAlert("گالری محصول بروزرسانی شد.", "success");
    }).catch(() => utils.showAlert("بروزرسانی گالری انجام نشد.", "error"));
  };

  const sendData_content_img = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    var formData = new FormData();
    formData.append("content_img", content_img);
    formData.append("product_id", product._id);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_content_img", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          $.unblockUI();
          //   history.push("/dashboard/showProducts");
          utils.showAlert("فایل با موفقیت آپلود شد.", "success");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };
  const sendData_cover_img = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    var formData = new FormData();
    formData.append("cover_img", cover_img);
    formData.append("product_id", product._id);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_cover_img", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          $.unblockUI();
          //   history.push("/dashboard/showProducts");
          utils.showAlert("فایل با موفقیت آپلود شد.", "success");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };
  const sendData_cover_video = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    var formData = new FormData();
    formData.append("cover_video", cover_video);
    formData.append("product_id", product._id);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_cover_video", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          $.unblockUI();
          //   history.push("/dashboard/showProducts");
          utils.showAlert("فایل با موفقیت آپلود شد.", "success");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  const [
    edit_product_error,
    edit_product_loading,
    edit_product_data,
    edit_product,
  ] = useRequest({
    method: "post",
    url: "/edit_product",
    body: {
      product_id: product._id,
      title,
      little_description: little_des,
      description: des,
      price,
      original_price,
      slug,
      support_price,
      discount,
      last_product_type,
      last_product_id,
      instagram,
      ineligible,
      is_hidden,
      consultation_only,
      store_category,
      sku,
      stock,
      shipping_note,
      store_specs: store_specs_text
        .split("\n")
        .map((line) => line.split(/[:：]/, 2))
        .filter(([label, value]) => label && value)
        .map(([label, value]) => ({ label: label.trim(), value: value.trim() })),
      box1: { title: box1Title, description: box1Description },
      box2: { title: box2Title, description: box2Description },
      box3: { title: box3Title, description: box3Description },
      box4: { title: box4Title, description: box4Description },
      box5: { title: box5Title, description: box5Description },
      box6: { title: box6Title, description: box6Description },
    },
    isFunction: true,
  });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن محصول جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن محصول</h4>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <fieldset class="form-group">
                        <h6>عنوان</h6>
                        <input
                          type="text"
                          class="form-control"
                          id="basicInput"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          placeholder="عنوان محصول را وارد کنید"
                        />
                      </fieldset>
                    </div>
                    <div class="col-md-6">
                      <fieldset class="form-group">
                        <h6>اسلاگ</h6>
                        <input
                          type="text"
                          class="form-control"
                          id="basicInput"
                          value={slug}
                          onChange={(e) => set_slug(e.target.value)}
                          placeholder="اسلاگ محصول را وارد کنید"
                        />
                      </fieldset>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <h6>نوع</h6>
                      <fieldset class="form-group">
                        <select
                          class="custom-select"
                          id="customSelect"
                          value={type}
                          onChange={(e) => setType(e.target.value)}
                          disabled
                        >
                          <option selected value="">
                            نوع محصول را انتخاب کنید
                          </option>
                          <option value="courses">دوره ها</option>
                          <option value="products">محصولات</option>
                          <option value="books">کتاب</option>
                          <option value="store">فروشگاه (کالای فیزیکی)</option>
                          <option value="frequency">فرکانسیک</option>
                          <option value="videos">لایو ها و ویدیو ها</option>
                          <option value="results">نتایج دوره ها</option>
                        </select>
                      </fieldset>
                    </div>
                  </div>
                  {type === "store" ? (
                    <div class="card" style={{ border: "1px solid #ffdbc8", marginBottom: "1.5rem" }}>
                      <div class="card-header"><h5 class="card-title">اطلاعات کالای فیزیکی</h5></div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6"><fieldset class="form-group"><h6>دسته‌بندی فروشگاه</h6><input class="form-control" value={store_category} onChange={(e) => set_store_category(e.target.value)} /></fieldset></div>
                          <div class="col-md-6"><fieldset class="form-group"><h6>کد کالا (SKU)</h6><input class="form-control" value={sku} onChange={(e) => set_sku(e.target.value)} /></fieldset></div>
                        </div>
                        <div class="row">
                          <div class="col-md-6"><fieldset class="form-group"><h6>موجودی انبار</h6><input type="number" min="0" class="form-control" value={stock} onChange={(e) => set_stock(e.target.value)} /></fieldset></div>
                          <div class="col-md-6"><fieldset class="form-group"><h6>یادداشت ارسال</h6><input class="form-control" value={shipping_note} onChange={(e) => set_shipping_note(e.target.value)} /></fieldset></div>
                        </div>
                        <div class="row"><div class="col-12"><fieldset class="form-group"><h6>مشخصات فنی</h6><textarea class="form-control" rows="4" value={store_specs_text} onChange={(e) => set_store_specs_text(e.target.value)} placeholder="هر خط: عنوان: مقدار" /></fieldset></div></div>
                        <div class="row"><div class="col-12"><fieldset class="form-group"><h6>گالری تصاویر</h6>{store_gallery.length ? <div class="mb-1">{store_gallery.map((image, index) => <span class="badge badge-light ml-1" key={image.name}>{index + 1}. {image.alt || image.name} <button type="button" class="btn btn-sm text-danger p-0 mr-1" onClick={() => set_store_gallery((items) => items.filter((_, itemIndex) => itemIndex !== index))}>×</button></span>)}</div> : null}<input type="file" class="form-control" multiple accept="image/*" onChange={(e) => set_new_store_images(Array.from(e.target.files || []))} /><small class="form-text text-muted">برای حذف، روی × بزنید. تصویر اول کاور فروشگاه است.</small><button type="button" class="btn btn-outline-primary mt-1" onClick={updateStoreGallery}>ذخیره گالری</button></fieldset></div></div>
                      </div>
                    </div>
                  ) : null}
                  <div class="row">
                    <div class="col-md-6">
                      <fieldset class="form-group">
                        <h6>id محصول در سایت قبلی</h6>
                        <input
                          type="text"
                          class="form-control"
                          id="basicInput"
                          value={last_product_id}
                          onChange={(e) => setLast_product_id(e.target.value)}
                          placeholder="id محصول در سایت قبلی را وارد کنید"
                        />
                      </fieldset>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <fieldset class="form-group">
                        <h6>type محصول در سایت قبلی</h6>
                        <input
                          type="text"
                          class="form-control"
                          id="basicInput"
                          value={last_product_type}
                          onChange={(e) => setLast_product_type(e.target.value)}
                          placeholder="type محصول در سایت قبلی را وارد کنید"
                        />
                      </fieldset>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <h6>توضیحات کوتاه</h6>
                      <div class="card-content">
                        <div class="row">
                          <div class="col-12">
                            <fieldset class="form-group">
                              <CKEditor
                                onReady={(editor) => {
                                  console.log(
                                    "Editor is ready to use!",
                                    editor
                                  );
                                  // Insert the toolbar before the editable area.
                                  editor.ui
                                    .getEditableElement()
                                    .parentElement.insertBefore(
                                      editor.ui.view.toolbar.element,
                                      editor.ui.getEditableElement()
                                    );
                                }}
                                config={{
                                  // Use the German language for this editor.
                                  language: "fa",

                                  // ...
                                }}
                                // onReady={(editor) => {
                                //   // You can store the "editor" and use when it is needed.
                                //   console.log(
                                //     "Editor is ready to use!",
                                //     editor
                                //   );
                                // }}

                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setLittleDes(data);
                                }}
                                editor={DecoupledEditor}
                                data={little_des}

                                // onBlur={(event, editor) => {
                                //   console.log("Blur.", editor);
                                // }}
                                // onFocus={(event, editor) => {
                                //   console.log("Focus.", editor);
                                // }}
                              />
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <h6>توضیحات اصلی</h6>
                      <div class="card-content">
                        <div class="row">
                          <div class="col-12">
                            <fieldset class="form-group">
                              <CKEditor
                               onReady={(editor) => {
                                console.log(
                                  "Editor is ready to use!",
                                  editor
                                );
                                // Insert the toolbar before the editable area.
                                editor.ui
                                  .getEditableElement()
                                  .parentElement.insertBefore(
                                    editor.ui.view.toolbar.element,
                                    editor.ui.getEditableElement()
                                  );
                              }}
                                editor={DecoupledEditor}
                                data={des}
                                config={{
                                  // Use the German language for this editor.
                                  language: "fa",

                                  // ...
                                }}
                                // onReady={(editor) => {
                                //   // You can store the "editor" and use when it is needed.
                                //   console.log(
                                //     "Editor is ready to use!",
                                //     editor
                                //   );
                                // }}

                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setDes(data);
                                }}
                                // onBlur={(event, editor) => {
                                //   console.log("Blur.", editor);
                                // }}
                                // onFocus={(event, editor) => {
                                //   console.log("Focus.", editor);
                                // }}
                              />
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {type ? (
                    <>
                      {type !== "videos" && type !== "results" ? (
                        <>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت واقعی</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="مبلغ را وارد نماید"
                                  value={price}
                                  onChange={(e) => setPrice(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت اصلی (اختیاری)</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="قیمت قبل از تخفیف را وارد نمایید"
                                  value={original_price}
                                  onChange={(e) => set_original_price(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>قیمت پشتیبانی کل محصول</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="قیمت پشتیبانی را وارد نماید"
                                  value={support_price}
                                  onChange={(e) =>
                                    set_support_price(e.target.value)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>تخفیف</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="مبلغ تخفیف را وارد نمایید"
                                  value={discount}
                                  onChange={(e) => setDiscount(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس اول(پیشفرض: میخواهم بیشتر بدانم)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس اول"
                                  value={box1Title}
                                  onChange={(e) => setBox1Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس اول</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box1Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox1Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس دوم(پیشفرض: نحوه برگزاری دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس دوم"
                                  value={box2Title}
                                  onChange={(e) => setBox2Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس دوم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box2Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox2Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس سوم(پیشفرض: تضمین موفقیت در این
                                  دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس سوم"
                                  value={box3Title}
                                  onChange={(e) => setBox3Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس سوم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box3Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox3Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس چهارم(پیشفرض: نحوه برگزاری دوره)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس چهارم"
                                  value={box4Title}
                                  onChange={(e) => setBox4Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس چهارم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box4Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox4Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>
                                  عنوان باکس پنجم(پیشفرض: درس‌ها و تمریناتم را
                                  چطور دریافت کنم؟)
                                </h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس پنجم"
                                  value={box5Title}
                                  onChange={(e) => setBox5Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس پنجم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box5Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox5Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>عنوان باکس ششم(پیشفرض: مرامنامه)</h6>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="basicInput"
                                  placeholder="عنوان باکس ششم"
                                  value={box6Title}
                                  onChange={(e) => setBox6Title(e.target.value)}
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس ششم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <CKEditor
                                       onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                        // Insert the toolbar before the editable area.
                                        editor.ui
                                          .getEditableElement()
                                          .parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editor.ui.getEditableElement()
                                          );
                                      }}
                                        editor={DecoupledEditor}
                                        data={box6Description}
                                        config={{
                                          // Use the German language for this editor.
                                          language: "fa",

                                          // ...
                                        }}
                                        // onReady={(editor) => {
                                        //   // You can store the "editor" and use when it is needed.
                                        //   console.log(
                                        //     "Editor is ready to use!",
                                        //     editor
                                        //   );
                                        // }}

                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setBox6Description(data);
                                        }}
                                        // onBlur={(event, editor) => {
                                        //   console.log("Blur.", editor);
                                        // }}
                                        // onFocus={(event, editor) => {
                                        //   console.log("Focus.", editor);
                                        // }}
                                      />
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div class="row">
                            <div class="col-12">
                              <h6>توضیحات باکس ششم</h6>
                              <div class="card-content">
                                <div class="row">
                                  <div class="col-12">
                                    <fieldset class="form-group">
                                      <textarea
                                        class="form-control"
                                        id="basicTextarea"
                                        rows="3"
                                        placeholder="ناحیه متنی"
                                        value={box6Description}
                                        onChange={(e) =>
                                          setBox6Description(e.target.value)
                                        }
                                      ></textarea>
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}

                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>درخواست مشاوره رایگان به جای خرید</h6>
                                <label><input type="checkbox" checked={consultation_only} onChange={(e) => set_consultation_only(e.target.checked)} /> نمایش فرم نام و موبایل</label>
                                <small className="form-text text-muted">فرم مشاوره جایگزین خرید یا پیام عدم امکان خرید می‌شود. درخواست‌ها در «درخواست‌های مشاوره» ذخیره می‌شوند.</small>
                              </fieldset></div></div>
                          <div className="row"><div className="col-md-6"><fieldset className="form-group">
                                <h6>غیر قابل خرید</h6>
                                <input
                                  type="checkbox"
                                  checked={ineligible}
                                  defaultChecked={ineligible}
                                  onChange={(e) =>
                                    set_ineligible(e.target.checked)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>پنهان از فهرست عمومی سایت</h6>
                                <input
                                  type="checkbox"
                                  checked={is_hidden}
                                  onChange={(e) =>
                                    set_is_hidden(e.target.checked)
                                  }
                                />
                                <small class="form-text text-muted">
                                  این مورد در فهرست دوره‌ها و محصولات سایت نمایش داده نمی‌شود.
                                </small>
                              </fieldset>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <fieldset class="form-group">
                                <h6>دوره اینستاگرام</h6>
                                <input
                                  type="checkbox"
                                  placeholder="دوره اینستاگرام"
                                  checked={instagram}
                                  defaultChecked={instagram}
                                  onChange={(e) =>
                                    set_instagram(e.target.checked)
                                  }
                                />
                              </fieldset>
                            </div>
                          </div>
                        </>
                      ) : null}
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset>
                            <h6>تصویر کاور محصول</h6>
                            <div class="input-group">
                              <div class="input-group-prepend"></div>
                              <div class="input-group">
                                <div class="custom-file">
                                  <input
                                    type="file"
                                    class="custom-file-input"
                                    id="inputGroupFile02"
                                    onChange={(e) =>
                                      set_cover_img(e.target.files[0])
                                    }
                                  />
                                  <label
                                    class="custom-file-label"
                                    for="inputGroupFile02"
                                    aria-describedby="inputGroupFileAddon02"
                                  >
                                    {cover_img ? cover_img.name : "انتخاب فایل"}
                                  </label>
                                </div>
                                <button
                                  onClick={() => sendData_cover_img()}
                                  style={{
                                    marginRight: "1rem",
                                  }}
                                  type="button"
                                  class="btn btn-success mr-1 "
                                >
                                  اپلود
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset>
                            <h6>ویدیو کاور محصول</h6>
                            <div class="input-group">
                              <div class="input-group-prepend"></div>
                              <div class="input-group">
                                <div class="custom-file">
                                  <input
                                    type="file"
                                    class="custom-file-input"
                                    id="inputGroupFile02"
                                    onChange={(e) =>
                                      set_cover_video(e.target.files[0])
                                    }
                                  />
                                  <label
                                    class="custom-file-label"
                                    for="inputGroupFile02"
                                    aria-describedby="inputGroupFileAddon02"
                                  >
                                    {cover_video
                                      ? cover_video.name
                                      : "انتخاب فایل"}
                                  </label>
                                </div>
                                <button
                                  onClick={() => sendData_cover_video()}
                                  style={{
                                    marginRight: "1rem",
                                  }}
                                  type="button"
                                  class="btn btn-success mr-1 "
                                >
                                  اپلود
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset>
                            <h6>تصویر محتوای محصول</h6>
                            <div class="input-group">
                              <div class="input-group-prepend"></div>
                              <div
                                class="input-group"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div class="custom-file">
                                  <input
                                    type="file"
                                    class="custom-file-input"
                                    id="inputGroupFile02"
                                    onChange={(e) =>
                                      set_content_img(e.target.files[0])
                                    }
                                  />
                                  <label
                                    class="custom-file-label"
                                    for="inputGroupFile02"
                                    aria-describedby="inputGroupFileAddon02"
                                  >
                                    {content_img
                                      ? content_img.name
                                      : "انتخاب فایل"}
                                  </label>
                                </div>
                                <button
                                  onClick={() => sendData_content_img()}
                                  style={{
                                    marginRight: "1rem",
                                  }}
                                  type="button"
                                  class="btn btn-success mr-1 "
                                >
                                  اپلود
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <button
                    onClick={() => {
                      let $white = "#fff";
                      $.blockUI({
                        message:
                          '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                        // timeout: 2000, //unblock after 2 seconds
                        overlayCSS: {
                          backgroundColor: $white,
                          opacity: 0.8,
                          cursor: "wait",
                        },
                        css: {
                          border: 0,
                          padding: 0,
                          backgroundColor: "transparent",
                        },
                      });
                      edit_product()
                        .then(() => {
                          utils.showAlert(
                            "محصول با موفقیت آپدیت شد",
                            "success"
                          );
                          history.push("/dashboard/showProducts");
                          $.unblockUI();
                        })
                        .catch(() => {
                          utils.showAlert("خطایی به وجود آمد", "error");
                          $.unblockUI();
                        });
                    }}
                    style={{ marginTop: "1rem" }}
                    type="button"
                    class="btn btn-success mr-1 mb-1"
                  >
                    ویرایش
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { EditProduct };
